var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isItemVisible,
          expression: "isItemVisible",
        },
      ],
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("m-description", {
        ref: "description",
        attrs: { "can-edit": true },
        on: {
          edit: function ($event) {
            return _vm.editListGroupItem(true)
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "list-group-item",
          class: { "archived-item": _vm.listGroupItem.is_archive === 1 },
        },
        [
          _c("div", { staticClass: "list-group-item__left-side" }, [
            _c("div", { staticClass: "list-group-item__label" }, [
              _vm._v(" " + _vm._s(_vm.listGroupItem.name) + " "),
              _vm.listGroupItem.module
                ? _c("span", { staticClass: "list-group-item__description" }, [
                    _vm._v(" " + _vm._s(_vm.itemModule) + " "),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "list-group-item__actions" },
            [
              _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      boundary: "window",
                      content: "Редактировать",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Редактировать',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: { size: "iconic", icon: "edit" },
                on: { click: _vm.editListGroupItem },
              }),
              _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      boundary: "window",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "list-group__actions-remove",
                attrs: {
                  size: "iconic",
                  icon: { icon: "trash", color: "secondary" },
                  disabled: _vm.listGroupItem.is_system,
                },
                on: { click: _vm.deleteListGroupItem },
              }),
              _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      boundary: "window",
                      content: "Переместить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Переместить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "document-item__move",
                attrs: { size: "iconic", icon: "arrows-constructor" },
              }),
              _c(
                "b-popover",
                {
                  ref: "popover",
                  attrs: {
                    target: `list-group-item-actions-${_vm.listGroupItem.id}`,
                    placement: "bottomleft",
                    triggers: "click blur",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "list-group-item__actions-popover" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "list-group-item__actions-popover-item",
                          on: { click: _vm.editListGroupItem },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item-icon",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 14 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.33943 1.62805L8.63232 0.920947L8.63232 0.920948L9.33943 1.62805ZM10.8557 1V0V1ZM13 3.14431H14H13ZM12.3719 4.66057L11.6648 3.95346L11.6648 3.95346L12.3719 4.66057ZM5.16971 11.8628L5.43283 12.8276C5.60073 12.7818 5.75376 12.693 5.87682 12.5699L5.16971 11.8628ZM1 13L0.0352364 12.7369C-0.0591854 13.0831 0.0391427 13.4534 0.292893 13.7071C0.546642 13.9609 0.916904 14.0592 1.26312 13.9648L1 13ZM2.13719 8.8303L1.43009 8.12319C1.30703 8.24625 1.21822 8.39929 1.17243 8.56718L2.13719 8.8303ZM10.0465 2.33516C10.1528 2.2289 10.2789 2.14461 10.4178 2.08711L9.65241 0.239346C9.27093 0.397362 8.9243 0.62897 8.63232 0.920947L10.0465 2.33516ZM10.4178 2.08711C10.5566 2.0296 10.7054 2 10.8557 2V0C10.4428 0 10.0339 0.0813298 9.65241 0.239346L10.4178 2.08711ZM10.8557 2C11.006 2 11.1548 2.0296 11.2936 2.08711L12.059 0.239346C11.6775 0.0813296 11.2686 0 10.8557 0V2ZM11.2936 2.08711C11.4324 2.14461 11.5586 2.2289 11.6648 2.33516L13.0791 0.920947C12.7871 0.628971 12.4404 0.397363 12.059 0.239346L11.2936 2.08711ZM11.6648 2.33516C11.7711 2.44142 11.8554 2.56757 11.9129 2.7064L13.7607 1.94103C13.6026 1.55955 13.371 1.21292 13.0791 0.920947L11.6648 2.33516ZM11.9129 2.7064C11.9704 2.84523 12 2.99403 12 3.14431H14C14 2.7314 13.9187 2.32252 13.7607 1.94103L11.9129 2.7064ZM12 3.14431C12 3.29459 11.9704 3.44339 11.9129 3.58222L13.7607 4.34759C13.9187 3.9661 14 3.55722 14 3.14431H12ZM11.9129 3.58222C11.8554 3.72105 11.7711 3.8472 11.6648 3.95346L13.0791 5.36768C13.371 5.0757 13.6026 4.72907 13.7607 4.34759L11.9129 3.58222ZM11.6648 3.95346L4.46261 11.1557L5.87682 12.5699L13.0791 5.36767L11.6648 3.95346ZM4.9066 10.898L0.736884 12.0352L1.26312 13.9648L5.43283 12.8276L4.9066 10.898ZM1.96476 13.2631L3.10196 9.09342L1.17243 8.56718L0.0352364 12.7369L1.96476 13.2631ZM2.8443 9.53741L10.0465 2.33516L8.63232 0.920948L1.43009 8.12319L2.8443 9.53741ZM7 4L10 7L11.4142 5.58579L8.41421 2.58579L7 4Z",
                                      fill: "#8E9CBB",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item-label",
                            },
                            [_vm._v("Редактировать")]
                          ),
                        ]
                      ),
                      _vm.listGroupItem.is_archive === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item",
                              on: { click: _vm.moveToArchive },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "list-group-item__actions-popover-item-icon",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "17",
                                        height: "15",
                                        viewBox: "0 0 17 15",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1 5H0V6H1V5ZM16 5V6H17V5H16ZM2 5V4H1V5H2ZM15 5H16V4H15V5ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9V7ZM10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7V9ZM14.5003 0H2.4997V2H14.5003V0ZM2.4997 0C1.12273 0 0 1.11598 0 2.49575H2C2 2.22552 2.22232 2 2.4997 2V0ZM0 2.49575V5H2V2.49575H0ZM17 5V2.49575H15V5H17ZM17 2.49575C17 1.11598 15.8773 0 14.5003 0V2C14.7777 2 15 2.22552 15 2.49575H17ZM1 6H16V4H1V6ZM13.4997 13H3.50031V15H13.4997V13ZM3.50031 13C3.22221 13 3 12.7741 3 12.5043H1C1 13.8844 2.12339 15 3.50031 15V13ZM3 12.5043V5H1V12.5043H3ZM14 5V12.5043H16V5H14ZM14 12.5043C14 12.7741 13.7778 13 13.4997 13V15C14.8766 15 16 13.8844 16 12.5043H14ZM2 6H15V4H2V6ZM7 9H10V7H7V9Z",
                                          fill: "#8E9CBB",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "list-group-item__actions-popover-item-label",
                                },
                                [_vm._v(" Переместить в архив ")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.listGroupItem.is_archive === 1
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item",
                              on: { click: _vm.moveFromArchive },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "list-group-item__actions-popover-item-icon",
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "14",
                                        viewBox: "0 0 16 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7",
                                          stroke: "#8E9CBB",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "list-group-item__actions-popover-item-label",
                                },
                                [_vm._v(" Восстановить из архива ")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "list-group-item__actions-popover-item",
                          on: { click: _vm.deleteListGroupItem },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item-icon",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    "data-v-551a1bd6": "",
                                    width: "13",
                                    height: "15",
                                    viewBox: "0 0 13 15",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "data-v-551a1bd6": "",
                                      d: "M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item__actions-popover-item-label",
                            },
                            [_vm._v("Удалить")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }